<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-share-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="share-text">系统检测到你未登录，请先登录</div>
                </div>

                <div class="u-btn ok" @click="call_login"></div>      
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
import mslogin from '@/assets/js/msLogin.js';

export default {
    data (){
        return {
            dialogVisible : false,
            shareTxt : '组队成功后可获得周年庆集结大礼包一份快去邀请好友加入小队吧！',
            gid : '',
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功");
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.invite)
            .then(res => {
                _this.shareTxt = res.data.content ? res.data.content : ('【阿斗赶集】打野队友弃我！梦三大陆逐我！甚至反补我！重生一世，今天是阿斗赶集，谁帮我砍价？' + _this.$global.domain + '?key=' + res.data.key)
            },rej => {
                _this.$toast('请稍后再试')
                _this.shareTxt = '请稍后再试'
            });
        },
        call_login(){
            mslogin.open();
        },       
    },
}
</script>

<style scoped>
/* share */
.m-share-modal {
    width: 584px;
    height: 344px;
    font-size: 22px;
    color: #a1837d;
    text-align: center;
    background-image: url(~@/assets/images/utils/bg-modal-msg.png);
}

.dialog-wrapper{
    padding: 90px 38px 0;
}

.m-share-modal h6 {
    /* height: 14px; */
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 15px;
}

.m-share-modal .share-text {
    padding: 0 45px;
    word-break: break-all;
}

.m-share-modal .u-btn.ok {
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 222px;
    height: 66px;
    margin-left: -111px;
    background-image: url(~@/assets/images/utils/btn-ok.png);
}
</style>


// WEBPACK FOOTER //
// src/components/ShareWarn/shareModal.vue